export default __webpack_public_path__ + "static/media/bgLogin.7bf6b02e.png";